export function mapPromotion(promotion: App.Bedbank.PromotionsEdit, isArchived: boolean) {
  return {
    ...promotion,
    cancellationPolicy: promotion.cancellationPolicy || null,
    deletedAt: isArchived ? (!promotion.deletedAt ? new Date().toISOString() : promotion.deletedAt) : undefined,
  };
}
